<template>
  <article class="article-body">
    <slot />

    <div class="brief">
      <p v-text="brief" />
    </div>

    <ContentHandler v-for="(item, index) in article" :key="index" :item="item" />
    <p id="js-warning-text" ref="warning-text">
      <strong>★《鏡週刊》關心您：未滿18歲禁止飲酒，飲酒過量害人害己，酒後不開車，安全有保障。</strong>
    </p>
    <a
      :href="`https://www.mirrormedia.mg/campaigns/whisky2021/index.html#${brand}`"
      ref="more"
      class="more"
      target="_blank"
      rel="noopener noreferrer"
    >
      看更多
    </a>
  </article>
</template>

<script>
import { article, brand, brief } from '../../content'
import ContentHandler from './ContentHandler.vue'

export default {
  name: 'UiArticleBody',

  components: {
    ContentHandler,
  },

  data() {
    return {
      article,
      brand,
      brief
    }
  },

  mounted() {
    import('intersection-observer').then(() => {
      const element = this.$refs['warning-text']
      const observer = new IntersectionObserver(
        function callback(entries) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.$refs.more.classList.add('active')
            } else {
              this.$refs.more.classList.remove('active')
            }
          })
        }.bind(this),
        {
          threshold: 1,
        }
      )
      observer.observe(element)
    })
  }
}
</script>

<style lang="scss" scoped>
.article-body {
  position: relative;
  padding-bottom: calc(10vh + 60px);
  font-size: 15px;
  line-height: 2;
  @media screen and (min-width: 1024px) {
    padding-bottom: 60px;
  }

  > * {
    margin: 40px auto;
    padding-left: 5%;
    padding-right: 5%;
    @media screen and (min-width: 768px) {
      padding-left: 33px;
      padding-right: 33px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .brief {
    margin-bottom: 48px;
    font-size: 17px;
    @media screen and (min-width: 996px) {
      margin-bottom: 60px;
      font-size: 18px;
      line-height: 1.67;
    }

    + * {
      margin-top: 0;
    }

    p + p {
      margin-top: 2em;
    }
  }
  .more {
    display: block;
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    width: 90%;
    margin: 0;
    color: #fff;
    text-align: center;
    background-color: #B64900;
    border-radius: 2px;
    transition: 2s bottom ease-in-out;
    &.active {
      bottom: 100px;
    }
    @media screen and (min-width: 996px) {
      display: none;
    }
  }
}
</style>